function fn(haveSubscription: boolean): boolean {
    return haveSubscription !== true;
}

export default fn;
